var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-delivery-relatedlist"},[(_vm.access.Act_New === true)?[(!_vm.hideAction)?[_c('Action',{attrs:{"invoiceId":_vm.invoiceId}})]:[_c('kst-warning',{staticClass:"mb-4",attrs:{"items":_vm.deliveryWarning}})]]:_vm._e(),_c('Row',{attrs:{"access":_vm.access,"items":_vm.items}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }